import React, { useState, useMemo, useEffect } from 'react'
import { Table, Form, Badge, Button, Modal, Row, Col, Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { EqInlab } from './EqInlab'
import {
  computarGrupoInfoMap,
  esEquipoEntregable,
} from '../../utils/gruposEquipos'
import ModalIncluirDependienteCert from '../Ot/ModalIncluirDependienteCert'

/** Equipo estÃ¡ en laboratorio si tiene fechaIngreso pero no fechaSalida */
const eqEstaIngresado = (eq) => Boolean(eq?.fechaIngreso) && !eq?.fechaSalida

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' })
    : null

const fechaSegunEstado = (eq) => {
  if (!eq) return null
  const map = {
    'Finalizado':    { label: 'Procesado', date: eq.fechaProcesado },
    'Aprobado':      { label: 'Aprobado',  date: eq.fechaAprobado },
    'Entregado':     { label: 'Entregado', date: eq.fechaEntrega },
    'Cancelado':     { label: 'Aplazado',  date: eq.fechaAplazado },
    'No Finalizado': { label: 'Creado',    date: eq.createdAt },
  }
  return map[eq.estado] || null
}

const estadoBadge = (estado) => ({
  'Aprobado':      'success',
  'Finalizado':    'primary',
  'No Finalizado': 'warning',
  'Entregado':     'secondary',
  'Cancelado':     'danger',
})[estado] || 'dark'

function mostrarEquipo(eq) {
  return eq.equipo?.estado === 'Aprobado' || eqEstaIngresado(eq.equipo)
}

/**
 * Reordena `[{item, idx}]` según criterio de agrupamiento padre↔hijos.
 * - `padre_dep`   → agrupa por grupoNum, dentro de cada grupo padre primero y luego hijos a,b,c…
 *                   Los equipos sueltos (sin pareja) van al final ordenados por nombre.
 * - `padres_first`→ todos los padres primero, luego hijos, luego sueltos. Cada categoría por nombre.
 * - `deps_first`  → todos los hijos primero, luego padres, luego sueltos. Cada categoría por nombre.
 *
 * Reusa `grupoInfoByIdx` calculado en el componente (Map<idx, {rol, grupoNum, letra?}>).
 */
function ordenarPorGrupo(lista, criterio, grupoInfoByIdx) {
  const clasificar = ({ idx }) => {
    const g = grupoInfoByIdx.get(idx)
    if (!g) return { tipo: 'suelto', grupoNum: 9999, letra: '' }
    return { tipo: g.rol, grupoNum: g.grupoNum, letra: g.letra || '' }
  }
  const nombreDe = ({ item }) => item?.equipo?.snapshot?.item || ''
  const conClave = lista.map((x) => ({ ...x, cls: clasificar(x) }))

  if (criterio === 'padre_dep') {
    return conClave.sort((a, b) => {
      if (a.cls.tipo === 'suelto' && b.cls.tipo !== 'suelto') return 1
      if (b.cls.tipo === 'suelto' && a.cls.tipo !== 'suelto') return -1
      if (a.cls.tipo === 'suelto' && b.cls.tipo === 'suelto') {
        return nombreDe(a).localeCompare(nombreDe(b))
      }
      if (a.cls.grupoNum !== b.cls.grupoNum) return a.cls.grupoNum - b.cls.grupoNum
      // Mismo grupo → padre antes que hijo, hijos por letra.
      if (a.cls.tipo === 'padre' && b.cls.tipo === 'hijo') return -1
      if (a.cls.tipo === 'hijo' && b.cls.tipo === 'padre') return 1
      return (a.cls.letra || '').localeCompare(b.cls.letra || '')
    })
  }

  const ordenTipo = criterio === 'deps_first'
    ? { hijo: 0, padre: 1, suelto: 2 }
    : { padre: 0, hijo: 1, suelto: 2 } // padres_first o default
  return conClave.sort((a, b) => {
    const dA = ordenTipo[a.cls.tipo]
    const dB = ordenTipo[b.cls.tipo]
    if (dA !== dB) return dA - dB
    return nombreDe(a).localeCompare(nombreDe(b))
  })
}

export const Selecteditems = ({
  equipos,
  infoActa,
  setModal,
  setVentana,
  crearActa,
  Validacion,
  // controles movidos desde Actaentrega
  entrega,
  onEntregaChange,
  obsGen,
  onObsChange,
}) => {
  const [modalitem, setModalitem] = useState(false)
  const [itemIn,    setItemIn]    = useState({})

  const [filterItem,        setFilterItem]        = useState('')
  const [filterConsecutivo, setFilterConsecutivo] = useState('')
  const [filterSerie,       setFilterSerie]       = useState('')
  const [filterSede,        setFilterSede]        = useState('')
  const [sortAsc,           setSortAsc]           = useState(true)
  // Ordenamiento por grupo (spec items-adicionales-equipo-dependiente).
  // '' | 'padre_dep' | 'padres_first' | 'deps_first'
  const [groupOrder,        setGroupOrder]        = useState('')
  // Trackea qué criterio fue el último usado; el otro se ignora hasta que se reactive.
  const [lastSortUsed,      setLastSortUsed]      = useState('nombre') // 'nombre' | 'grupo'

  const cambiarSortNombre = () => {
    setSortAsc((p) => !p)
    setLastSortUsed('nombre')
  }
  const cambiarGroupOrder = (e) => {
    setGroupOrder(e.target.value)
    setLastSortUsed('grupo')
  }

  // Sedes únicas presentes en los equipos de esta OT (desde snapshot)
  const sedeOptions = useMemo(() => {
    const set = new Set()
    equipos.forEach(eq => {
      const s = eq.equipo?.snapshot?.sede
      if (s) set.add(s)
    })
    return Array.from(set).sort()
  }, [equipos])

  // â”€â”€ Selecciones (persistentes por Ã­ndice original) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [selecciones, setSelecciones] = useState(() =>
    equipos.map(() => ({ tipoEntrega: 'NA', checked: false }))
  )
  useEffect(() => {
    setSelecciones(equipos.map(() => ({ tipoEntrega: 'NA', checked: false })))
  }, [equipos])

  const getSel = (idx) => selecciones[idx] ?? { tipoEntrega: 'NA', checked: false }

  // ── Grupos padre↔hijos (spec items-adicionales-equipo-dependiente) ──────
  // Mapa idx → { rol: 'padre'|'hijo', grupoNum, letra? } y helpers de resolución.
  const grupoInfoByIdx = useMemo(() => {
    const eqInOts = equipos.map((w) => w?.equipo)
    const info = computarGrupoInfoMap(eqInOts)
    const byIdx = new Map()
    equipos.forEach((w, idx) => {
      const g = info.get(String(w?.equipo?._id))
      if (g) byIdx.set(idx, g)
    })
    return byIdx
  }, [equipos])

  // Dado idx de padre, devuelve los índices de sus hijos presentes en `equipos[]`.
  const hijosIdxDePadre = (padreIdx) => {
    const w = equipos[padreIdx]
    const padreFisicoId = String(w?.equipo?.equipo?._id || w?.equipo?.equipo || '')
    if (!padreFisicoId) return []
    const out = []
    equipos.forEach((h, hIdx) => {
      const dep = h?.equipo?.equipo?.equipoDependiente
      if (dep && String(dep._id || dep) === padreFisicoId) out.push(hIdx)
    })
    return out
  }

  // Dado idx de hijo, devuelve idx del padre si está visible en `equipos[]` (-1 si no).
  const padreIdxDeHijo = (hijoIdx) => {
    const w = equipos[hijoIdx]
    const dep = w?.equipo?.equipo?.equipoDependiente
    if (!dep) return -1
    const padreFisicoId = String(dep._id || dep)
    return equipos.findIndex(
      (x) => String(x?.equipo?.equipo?._id || x?.equipo?.equipo || '') === padreFisicoId
    )
  }

  // Decisión "recordada" por acta cuando se marca padre en columna Certificado.
  // Se resetea al cambiar `equipos` o `entrega`.
  const [decisionParejaCert, setDecisionParejaCert] = useState(null) // null | 'incluir' | 'soloPadre'
  const [modalCertPareja, setModalCertPareja] = useState(null)
  //   modalCertPareja = { padreIdx, hijosIdx, checked }
  useEffect(() => {
    setDecisionParejaCert(null)
  }, [equipos, entrega])

  // â”€â”€ Lista filtrada en orden visible â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const equiposFiltrados = useMemo(() => {
    let lista = equipos.map((item, idx) => ({ item, idx }))
    if (filterItem.trim()) {
      const q = filterItem.toLowerCase()
      lista = lista.filter(({ item }) => item.equipo?.snapshot?.item?.toLowerCase().includes(q))
    }
    if (filterConsecutivo.trim()) {
      const q = filterConsecutivo.toLowerCase()
      lista = lista.filter(({ item }) => item.equipo?.consecutivo?.toLowerCase().includes(q))
    }
    if (filterSerie.trim()) {
      const q = filterSerie.toLowerCase()
      lista = lista.filter(({ item }) => item.equipo?.snapshot?.serial?.toLowerCase().includes(q))
    }
    if (filterSede) {
      lista = lista.filter(({ item }) => item.equipo?.snapshot?.sede === filterSede)
    }
    const usarGrupo = lastSortUsed === 'grupo' && groupOrder
    if (usarGrupo) {
      return ordenarPorGrupo(lista, groupOrder, grupoInfoByIdx)
    }
    return lista.sort((a, b) => {
      const nA = a.item.equipo?.snapshot?.item || ''
      const nB = b.item.equipo?.snapshot?.item || ''
      return sortAsc ? nA.localeCompare(nB) : nB.localeCompare(nA)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipos, filterItem, filterConsecutivo, filterSerie, filterSede, sortAsc, groupOrder, lastSortUsed, grupoInfoByIdx])

  const visibles = useMemo(
    () => equiposFiltrados.filter(({ item: eq }) => mostrarEquipo(eq)),
    [equiposFiltrados]
  )

  // Aplica el toggle "Equipo" a un índice concreto, componiendo con Certificado si aplica.
  const _aplicarToggleEquipo = (next, i, checked, origen) => {
    const cur = next[i]?.tipoEntrega || 'NA'
    next[i] = {
      checked,
      tipoEntrega: checked
        ? (cur === 'Certificado' ? 'Certificado y Equipo' : 'Equipo')
        : (cur === 'Certificado y Equipo' ? 'Certificado' : 'NA'),
      origenSeleccion: origen, // 'manual' | 'auto'
    }
  }

  const toggleEquipo = (idx, checked) => {
    const info = grupoInfoByIdx.get(idx)
    const esPadre = info?.rol === 'padre'
    const hijosIdx = esPadre ? hijosIdxDePadre(idx) : []

    setSelecciones((prev) => {
      const next = [...prev]
      _aplicarToggleEquipo(next, idx, checked, 'manual')

      const omitidos = []
      hijosIdx.forEach((hIdx) => {
        const h = equipos[hIdx]
        if (checked) {
          // Al marcar padre: solo auto-marcar hijo si es entregable como Equipo (está ingresado).
          if (esEquipoEntregable(h?.equipo, 'Equipo')) {
            _aplicarToggleEquipo(next, hIdx, true, 'auto')
          } else {
            omitidos.push(h?.equipo?.snapshot?.serial || h?.equipo?._id)
          }
        } else {
          // Al desmarcar padre: desmarcar solo los que se marcaron automáticamente.
          if (next[hIdx]?.origenSeleccion === 'auto') {
            _aplicarToggleEquipo(next, hIdx, false, 'auto')
          }
        }
      })

      if (checked && omitidos.length > 0) {
        setTimeout(() => {
          Swal.fire({
            icon: 'info',
            title: 'Dependiente(s) omitido(s)',
            html: `Los siguientes equipos no están ingresados, se entrega solo el padre:<br/><strong>${omitidos.join('<br/>')}</strong>`,
            timer: 3500,
            showConfirmButton: false,
          })
        }, 0)
      }
      return next
    })
  }

  const _aplicarToggleCert = (next, i, checked, origen) => {
    const cur = next[i]?.tipoEntrega || 'NA'
    next[i] = {
      checked,
      tipoEntrega: checked
        ? (cur === 'Equipo' ? 'Certificado y Equipo' : 'Certificado')
        : (cur === 'Certificado y Equipo' ? 'Equipo' : 'NA'),
      origenSeleccion: origen,
    }
  }

  // Aplica una decisión de "incluir dependiente" a un grupo padre+hijos en columna Cert.
  const _aplicarDecisionCertPareja = (padreIdx, hijosIdx, checked, incluirHijos) => {
    setSelecciones((prev) => {
      const next = [...prev]
      _aplicarToggleCert(next, padreIdx, checked, 'manual')
      hijosIdx.forEach((hIdx) => {
        const h = equipos[hIdx]
        if (checked && incluirHijos) {
          if (esEquipoEntregable(h?.equipo, 'Certificado')) {
            _aplicarToggleCert(next, hIdx, true, 'auto')
          }
        } else if (!checked) {
          // Desmarcar padre → desmarcar solo los que se marcaron automáticamente.
          if (next[hIdx]?.origenSeleccion === 'auto') {
            _aplicarToggleCert(next, hIdx, false, 'auto')
          }
        }
      })
      return next
    })
  }

  const toggleCertificado = (idx, checked) => {
    const info = grupoInfoByIdx.get(idx)
    const esPadre = info?.rol === 'padre'
    const hijosIdx = esPadre ? hijosIdxDePadre(idx) : []
    const hijosConCert = hijosIdx.filter((hIdx) =>
      esEquipoEntregable(equipos[hIdx]?.equipo, 'Certificado')
    )

    // Sin hijos con certificado → path original
    if (!esPadre || hijosConCert.length === 0) {
      setSelecciones((prev) => {
        const next = [...prev]
        _aplicarToggleCert(next, idx, checked, 'manual')
        return next
      })
      return
    }

    // Al desmarcar: NO abre modal, respeta la decisión "recordada"
    if (!checked) {
      _aplicarDecisionCertPareja(idx, hijosConCert, false, false)
      return
    }

    // Al marcar y ya hay decisión recordada → aplicar sin preguntar
    if (decisionParejaCert === 'incluir') {
      _aplicarDecisionCertPareja(idx, hijosConCert, true, true)
      return
    }
    if (decisionParejaCert === 'soloPadre') {
      _aplicarDecisionCertPareja(idx, hijosConCert, true, false)
      return
    }

    // Primer marcado del acta → abrir modal
    setModalCertPareja({ padreIdx: idx, hijosIdx: hijosConCert, checked: true })
  }

  // Click en fila â†’ toggle segÃºn entrega y estado del equipo
  const handleRowClick = (idx, eq) => {
    const ingresado = eqEstaIngresado(eq.equipo)
    const aprobado  = eq.equipo?.estado === 'Aprobado'
    const sel = getSel(idx)
    if (entrega !== 'Certificado' && ingresado) {
      const isChecked = sel.tipoEntrega === 'Equipo' || sel.tipoEntrega === 'Certificado y Equipo'
      toggleEquipo(idx, !isChecked)
    } else if (entrega !== 'Equipo' && aprobado) {
      const isChecked = sel.tipoEntrega === 'Certificado' || sel.tipoEntrega === 'Certificado y Equipo'
      toggleCertificado(idx, !isChecked)
    }
  }

  // Seleccionar / deseleccionar todos los visibles
  const seleccionarFiltrado = () => {
    const todosChecked = visibles.every(({ idx }) => getSel(idx).checked)
    setSelecciones(prev => {
      const next = [...prev]
      visibles.forEach(({ item: eq, idx }) => {
        const ingresado = eqEstaIngresado(eq.equipo)
        if (todosChecked) {
          next[idx] = { checked: false, tipoEntrega: 'NA' }
        } else {
          let tipo = 'NA'
          if (entrega === 'Certificado')
            tipo = 'Certificado'
          else if (entrega === 'Equipo')
            tipo = ingresado ? 'Equipo' : 'NA'
          else
            tipo = ingresado ? 'Certificado y Equipo' : 'Certificado'
          next[idx] = { checked: tipo !== 'NA', tipoEntrega: tipo }
        }
      })
      return next
    })
  }

  // Parcial: solo seleccionados en orden visible
  const chargeEq = () => {
    const seleccionados = visibles
      .filter(({ idx }) => {
        const sel = getSel(idx)
        return sel.checked && sel.tipoEntrega !== 'NA'
      })
      .map(({ item: eq, idx }) => ({ ...eq, tipoEntrega: getSel(idx).tipoEntrega }))
      .filter(eq => eq.equipo?.estado !== 'Entregado')
      // Sanitización final (spec items-adicionales-equipo-dependiente 34.5): revalidar
      // que cada seleccionado sigue siendo entregable con su tipoEntrega actual, por si
      // el estado del equipo mutó entre el marcado y el envío.
      .filter(eq => esEquipoEntregable(eq.equipo, eq.tipoEntrega))

    if (seleccionados.length === 0) {
      Swal.fire({ icon: 'error', title: 'Sin selecciÃ³n', text: 'No hay Ã­tems seleccionados en la vista actual' })
      return
    }
    const invalidos = seleccionados.filter(
      eq => eq.tipoEntrega === 'Certificado' && eqEstaIngresado(eq.equipo)
    )
    if (invalidos.length > 0) {
      Swal.fire({ icon: 'warning', title: 'Equipos ingresados', text: 'Los equipos ingresados no pueden tener solo certificado. Selecciona "Certificado y Equipo" o "Equipo".' })
      return
    }
    infoActa.tipo = 'Parcial'
    infoActa.Equipos = seleccionados
    crearActa()
  }

  // Total: todos los visibles (en orden visible)
  const handleValidacionVisible = () => {
    Validacion(visibles.map(({ item }) => item))
  }

    const seleccionadosCount  = visibles.filter(({ idx }) => getSel(idx).checked).length
  const todosVisiblesChecked = visibles.length > 0 && visibles.every(({ idx }) => getSel(idx).checked)

  const cerrarModalCertPareja = () => setModalCertPareja(null)

  const onIncluirDependientesCert = (recordar) => {
    if (!modalCertPareja) return
    const { padreIdx, hijosIdx } = modalCertPareja
    _aplicarDecisionCertPareja(padreIdx, hijosIdx, true, true)
    if (recordar) setDecisionParejaCert('incluir')
    cerrarModalCertPareja()
  }

  const onSoloPadreCert = (recordar) => {
    if (!modalCertPareja) return
    const { padreIdx, hijosIdx } = modalCertPareja
    _aplicarDecisionCertPareja(padreIdx, hijosIdx, true, false)
    if (recordar) setDecisionParejaCert('soloPadre')
    cerrarModalCertPareja()
  }

  return (
    <>
      {/* Modal decisión "incluir dependiente en certificado" */}
      <ModalIncluirDependienteCert
        show={Boolean(modalCertPareja)}
        padre={modalCertPareja ? equipos[modalCertPareja.padreIdx]?.equipo : null}
        hijos={modalCertPareja ? modalCertPareja.hijosIdx.map(i => equipos[i]?.equipo) : []}
        onIncluir={onIncluirDependientesCert}
        onSoloPadre={onSoloPadreCert}
        onCancelar={cerrarModalCertPareja}
      />

      {/* Modal equipos ingresados */}
      <Modal show={modalitem} onHide={() => setModalitem(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Equipos Ingresados</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EqInlab setVentana={setVentana} itemIn={itemIn} setModalitem={setModalitem} crearActa={crearActa} setModal={setModal} />
        </Modal.Body>
      </Modal>

      <div className="p-2">
              <Card className="mb-3 border-0 shadow-sm w-100">
          <Card.Header className="py-2 bg-white fw-semibold text-secondary w-100">
            <i className="bi bi-sliders me-2" />Configuración y Filtros
          </Card.Header>
          <Card.Body className="py-3 w-100">
            <Row className="g-2 align-items-end">
              {/* Â¿QuÃ© se entrega? */}
              <Col xs={12} md={2}>
                <Form.Label className="small fw-semibold mb-1">¿Qué se entrega?</Form.Label>
                <Form.Select size="sm" name="entrega" value={entrega || 'Certificado'} onChange={onEntregaChange}>
                  <option value="Certificado">Certificados</option>
                  <option value="Equipo">Equipos</option>
                  <option value="Certificado y Equipo">Certificados y Equipos</option>
                </Form.Select>
              </Col>

              {/* Sede */}
              <Col xs={12} md={2}>
                <Form.Label className="small fw-semibold mb-1">Sede</Form.Label>
                <Form.Select size="sm" value={filterSede} onChange={e => setFilterSede(e.target.value)}>
                  <option value="">Todas</option>
                  {sedeOptions.map(s => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </Form.Select>
              </Col>

              {/* Ítem */}
              <Col xs={6} md={2}>
                <Form.Label className="small fw-semibold mb-1">Filtrar Ítem</Form.Label>
                <Form.Control size="sm" placeholder="Buscar..." value={filterItem} onChange={e => setFilterItem(e.target.value)} />
              </Col>

              {/* Consecutivo */}
              <Col xs={6} md={1}>
                <Form.Label className="small fw-semibold mb-1">Consecutivo</Form.Label>
                <Form.Control size="sm" placeholder="Buscar..." value={filterConsecutivo} onChange={e => setFilterConsecutivo(e.target.value)} />
              </Col>

              {/* Serie */}
              <Col xs={6} md={1}>
                <Form.Label className="small fw-semibold mb-1">Serie</Form.Label>
                <Form.Control size="sm" placeholder="Buscar..." value={filterSerie} onChange={e => setFilterSerie(e.target.value)} />
              </Col>

                            {/* Ordenar por grupo (padre↔dependiente) */}
              <Col xs={12} md={3}>
                <Form.Label className="small fw-semibold mb-1">
                  Ordenar por pareja
                  {lastSortUsed === 'grupo' && groupOrder && (
                    <Badge bg="info" text="dark" className="ms-2" style={{ fontSize: '0.65rem' }}>activo</Badge>
                  )}
                </Form.Label>
                <Form.Select size="sm" value={groupOrder} onChange={cambiarGroupOrder}
                             title="Ordenar por relación padre↔dependiente (predomina si es el último aplicado)">
                  <option value="">Sin agrupar</option>
                  <option value="padre_dep">Padre → dependiente (agrupado)</option>
                  <option value="padres_first">Padres primero</option>
                  <option value="deps_first">Dependientes primero</option>
                </Form.Select>
              </Col>

              {/* Ordenar por nombre */}
              <Col xs={6} md={1} className="d-flex align-items-end">
                <Button size="sm"
                        variant={lastSortUsed === 'nombre' ? 'secondary' : 'outline-secondary'}
                        className="w-100"
                        onClick={cambiarSortNombre}
                        title="Ordenar por nombre de ítem (predomina si es el último aplicado)">
                  {sortAsc ? 'az-AZ' : 'za-ZA'}
                </Button>
              </Col>



              {/* ObservaciÃ³n */}
              <Col xs={12}>
                <Form.Label className="small fw-semibold mb-1">Observación del acta</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  size="sm"
                  placeholder="Agrega las observaciones del acta de entrega..."
                  value={obsGen || 'Se realiza envío de los certificados al correo autorizado por el cliente'}
                  onChange={onObsChange}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* */}
        <div className="d-flex align-items-center gap-2 mb-2">
          <Badge bg={seleccionadosCount > 0 ? 'primary' : 'secondary'}>
            {seleccionadosCount} / {visibles.length} seleccionados
          </Badge>
          <Button size="sm" variant={todosVisiblesChecked ? 'outline-danger' : 'outline-success'} onClick={seleccionarFiltrado}>
            <i className={`bi ${todosVisiblesChecked ? 'bi-dash-square' : 'bi-check-square'} me-1`} />
            {todosVisiblesChecked ? 'Deseleccionar visibles' : 'Seleccionar visibles'}
          </Button>
          {(filterItem || filterConsecutivo || filterSerie) && (
            <Badge bg="warning" text="dark">
              <i className="bi bi-funnel-fill me-1" />Filtros activos
            </Badge>
          )}
        </div>

        {/* */}
        <Table hover bordered responsive size="sm" className="mb-0">
          <thead className="table-dark">
            <tr>
              <th style={{ width: 42 }} className="text-center" title="Relación padre/dependiente">
                <i className="bi bi-diagram-3" />
              </th>
              <th>Ítem</th>
              <th>Marca</th>
              <th>Modelo</th>
              <th>Serie</th>
              <th>Sede</th>
              <th>Estado</th>
              <th>Consecutivo</th>
              {entrega !== 'Certificado' && <th className="text-center">Equipo</th>}
              {entrega !== 'Equipo'      && <th className="text-center">Certificado</th>}
            </tr>
          </thead>
          <tbody>
            {visibles.map(({ item: eq, idx }, rowNum) => {
              const ingresado  = eqEstaIngresado(eq.equipo)
              const sel        = getSel(idx)
              const isChecked  = sel.checked
              const fechaInfo  = fechaSegunEstado(eq.equipo)

              return (
                <tr
                  key={eq.equipo?._id || idx}
                  className={isChecked ? 'table-primary' : ''}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleRowClick(idx, eq)}
                >
                  {/* Columna Pareja — badge P1 / D1a según rol (spec items-adicionales-equipo-dependiente) */}
                  <td className="text-center align-middle" style={{ padding: '2px 1px' }}>
                    {(() => {
                      const g = grupoInfoByIdx.get(idx)
                      if (!g) return <span className="text-muted" style={{ fontSize: '0.7rem' }}>—</span>
                      const bg = g.rol === 'padre' ? 'bg-primary text-white' : 'bg-info text-dark'
                      const label = g.rol === 'padre'
                        ? `P${g.grupoNum}`
                        : `D${g.grupoNum}${g.letra || ''}`
                      const tooltip = g.rol === 'padre'
                        ? `Padre del grupo ${g.grupoNum}`
                        : `Dependiente ${g.grupoNum}${g.letra || ''} del grupo ${g.grupoNum}`
                      return (
                        <span
                          className={bg}
                          style={{
                            display: 'inline-block',
                            fontSize: '0.65rem',
                            fontWeight: 700,
                            padding: '2px 4px',
                            lineHeight: 1.1,
                            whiteSpace: 'nowrap',
                            letterSpacing: '-0.03em',
                            borderRadius: '3px',
                          }}
                          title={tooltip}
                        >
                          {label}
                        </span>
                      )
                    })()}
                  </td>

                  <td>
                    <div className="fw-semibold">{eq.equipo?.snapshot?.item}</div>
                    {ingresado && (
                      <Badge bg="info" style={{ fontSize: '0.65rem' }}>
                        <i className="bi bi-pin-map-fill me-1" />Ingresado
                      </Badge>
                    )}
                  </td>
                  <td>{eq.equipo?.snapshot?.marca}</td>
                <td>{eq.equipo?.snapshot?.modelo}</td>
                  <td>{eq.equipo?.snapshot?.serial}</td>
                  <td>{eq.equipo?.snapshot?.sede || 'â€”'}</td>
                  <td>
                    <Badge bg={estadoBadge(eq.equipo?.estado)}>{eq.equipo?.estado}</Badge>
                    {fechaInfo?.date && (
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>
                        {fechaInfo.label}: {formatDate(fechaInfo.date)}
                      </div>
                    )}
                  </td>
                  <td>{eq.equipo?.consecutivo}</td>

                  {/* Checkbox Equipo — sincronizado padre↔hijo (spec items-adicionales-equipo-dependiente) */}
                  {entrega !== 'Certificado' && (() => {
                    const g = grupoInfoByIdx.get(idx)
                    const esHijoConPadreVisible = g?.rol === 'hijo' && padreIdxDeHijo(idx) !== -1
                    return (
                      <td className="text-center" onClick={e => e.stopPropagation()}>
                        {ingresado ? (
                          <input
                            type="checkbox"
                            checked={sel.tipoEntrega === 'Equipo' || sel.tipoEntrega === 'Certificado y Equipo'}
                            disabled={esHijoConPadreVisible}
                            title={esHijoConPadreVisible ? 'Sincronizado con el equipo padre' : undefined}
                            onChange={e => toggleEquipo(idx, e.target.checked)}
                          />
                        ) : <span className="text-muted">N/A</span>}
                      </td>
                    )
                  })()}

                  
                  {/* Checkbox Certificado 
                    si el equipo esta ingresado no se puede emitir solo certificado, debe ser certificado y equipo o ninguno, es decir que se habilite el checkbox pero si se selecciona se marque equipo tambien, y si se deselecciona equipo se deseleccione certificado, pero no se deshabilite el checkbox de certificado
                    si el equipo no esta ingresado, el checkbox de certificado se habilita normalmente y no afecta al checkbox de equipo
                  */}
                    {entrega !== 'Equipo' &&  eq.equipo?.estado === 'Aprobado' && (
                      <td className="text-center" onClick={e => e.stopPropagation()}>
                        {ingresado ? (
                          // Si está ingresado, solo se puede "Certificado y Equipo" o "Equipo"
                          <input
                            type="checkbox"
                            checked={sel.tipoEntrega === 'Certificado y Equipo'}
                            onChange={e => {
                              // Si se selecciona, debe marcar ambos; si se deselecciona, solo desmarca certificado
                              if (e.target.checked) {
                                setSelecciones(prev => {
                                  const next = [...prev]
                                  next[idx] = { checked: true, tipoEntrega: 'Certificado y Equipo' }
                                  return next
                                })
                              } else {
                                setSelecciones(prev => {
                                  const next = [...prev]
                                  // Si estaba en 'Certificado y Equipo', al desmarcar queda solo 'Equipo'
                                  next[idx] = { checked: true, tipoEntrega: 'Equipo' }
                                  return next
                                })
                              }
                            }}
                          />
                        ) : eq.equipo?.estado === 'Aprobado' ? (
                          <input
                            type="checkbox"
                            checked={sel.tipoEntrega === 'Certificado' || sel.tipoEntrega === 'Certificado y Equipo'}
                            onChange={e => toggleCertificado(idx, e.target.checked)}
                          />
                        ) : <span className="text-muted">N/A</span>}
                      </td>
                    )}
                </tr>
              )
            })}
            {visibles.length === 0 && (
              <tr>
                <td colSpan={10} className="text-center text-muted py-4">
                  No se encontraron equipos con los filtros aplicados
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <hr />

        {equipos.length > 0 && (
          <>
            <div className="d-flex gap-2 justify-content-end flex-wrap">
              <Button variant="outline-primary" onClick={chargeEq} disabled={seleccionadosCount === 0}>
                <i className="bi bi-file-earmark-check me-1" />
                Acta Parcial ({seleccionadosCount} selec.)
              </Button>
              <Button variant="primary" onClick={handleValidacionVisible}>
                <i className="bi bi-file-earmark-text me-1" />
                Acta Total ({visibles.length} visibles)
              </Button>
            </div>
            <p className="text-muted small mt-2 text-end mb-0">
              <i className="bi bi-info-circle me-1" />
              Ambas acciones aplican <strong>solo sobre los equipos visibles</strong> según los filtros activos.
              <br />
              &quot;Acta Parcial&quot; usa los seleccionados. &quot;Acta Total&quot; usa todos los visibles, en el orden actual.
            </p>
          </>
        )}
      </div>
    </>
  )
}
